import React from 'react'
import { Link } from 'react-router-dom'

import XText from '../XText/XText'
import SquareWidget from '../SquareWidget/SquareWidget'
import Arrow from '../../icons/Arrow'

import HowWeAreWorking1 from '../../icons/checkform_blue.png'
import HowWeAreWorking2 from '../../icons/consultant.jpeg'
import HowWeAreWorking3 from '../../icons/buy_now_order.jpeg'
import HowWeAreWorking4 from '../../icons/mbridelivery.jpeg'

import './our-work.css'


const OurWork = () => (
  <section className='our-work'>
    <div className='section__content'>
      <div className='section__title flex-container--bottom-70'>
        <XText>Як</XText> ми працюємо?
      </div>
      <div className='flex-container--wrap'>
        <SquareWidget className='square-widget__work about-our-work'>
          <div className='big-number'>01</div>
          <img src={HowWeAreWorking1} alt="" />
          <div className='description'>
            <div className='description__title'>ОФОРМЛЕННЯ ЗАМОВЛЕННЯ</div>
            <div className='description__content'>Виберіть товар на сайті та зробіть замовлення</div>
          </div>
        </SquareWidget>
        <SquareWidget className='square-widget__work about-our-work'>
          <div className='big-number'>02</div>
          <img src={HowWeAreWorking2} alt="" />
          <div className='description'>
            <div className='description__title'>ЗВОРОТНІЙ ЗВ'ЯЗОК</div>
            <div className='description__content'>Протягом 20 хвилин наш менеджер зв'яжеться з Вами, щоб уточнити деталі замовлення</div>
          </div>
        </SquareWidget>
        <SquareWidget className='square-widget__work about-our-work'>
          <div className='big-number'>03</div>
          <img src={HowWeAreWorking3} alt="" />
          <div className='description'>
            <div className='description__title'>ЗАМОВЛЕННЯ ТОВАРУ</div>
            <div className='description__content'>Виконується замовлення товару у Польщі на базі</div>
          </div>
        </SquareWidget>
        <SquareWidget className='square-widget__work about-our-work'>
          <div className='big-number'>04</div>
          <img src={HowWeAreWorking4} alt="" />
          <div className='description'>
            <div className='description__title'>ДОСТАВКА ТОВАРУ</div>
            <div className='description__content'>Товар доставляється на склад, а потім до покупця</div>
          </div>
        </SquareWidget>

        <Link to='/catalog'>
          <SquareWidget className='square-widget__work square-widget__work--blue about-our-work'>
            <div>Перейти до каталогу</div>
            <Arrow height={100} width={100} />
          </SquareWidget>
        </Link>
      </div>
    </div>
  </section>
)

export default OurWork
